<template>
  <!-- mascaras -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Mascaras autônomas
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.mascara"
          @selected-data="(val) => (store.itensForm.values.mascara = val)"
        />
      </div>
    </div>
  </div>

  <!-- mascaras desc -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.mascara?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.mascara_descript"
        :info="'Inadequação da mascara'"
        label="Danificada, não contém..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.mascara_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- kits sbv -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Kits SBV
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.kits_sbv"
          @selected-data="(val) => (store.itensForm.values.kits_sbv = val)"
        />
      </div>
    </div>
  </div>

  <!-- kits desc -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.kits_sbv?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.kits_sbv_descript"
        :info="'Inadequação do kit'"
        label="Danificado, não contém..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.kits_sbv_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- dea -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        DEA
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.dea"
          @selected-data="(val) => (store.itensForm.values.dea = val)"
        />
      </div>
    </div>
  </div>

  <!-- DEA desc -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.dea?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.dea_descript"
        :info="'Inadequação do DEA'"
        label="Não funcional, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.dea_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- maca -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Maca envelope
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.maca"
          @selected-data="(val) => (store.itensForm.values.maca = val)"
        />
      </div>
    </div>
  </div>

  <!-- maca -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.maca?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.maca_descript"
        :info="'Inadequação da maca'"
        label="Danificado, não contém..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.maca_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- cordas-->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Cordas
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.cordas"
          @selected-data="(val) => (store.itensForm.values.cordas = val)"
        />
      </div>
    </div>
  </div>

  <!-- cordas desc -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.cordas?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.cordas_descript"
        :info="'Estado da cordas'"
        label="Danificado, rompida..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.cordas_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- ascensores e descensores-->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Ascensores e descensores
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.asce_desce"
          @selected-data="(val) => (store.itensForm.values.asce_desce = val)"
        />
      </div>
    </div>
  </div>

  <!-- asc e desc obs -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.asce_desce?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.asce_desce_descript"
        :info="'Inadequação'"
        label="Danificado, não possui..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.asce_desce_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- cinturões-->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Cinturões
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.cinturoes"
          @selected-data="(val) => (store.itensForm.values.cinturoes = val)"
        />
      </div>
    </div>
  </div>

  <!-- cintu obs -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.cinturoes?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.cinturoes_descript"
        :info="'Inadequação do cinturão'"
        label="Danificado, não possui..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.cinturoes_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- trava quedas-->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Trava quedas
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.trava_queda"
          @selected-data="(val) => (store.itensForm.values.trava_queda = val)"
        />
      </div>
    </div>
  </div>

  <!-- trava obs -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.trava_queda?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.trava_queda_descript"
        :info="'Inadequação do trava q.'"
        label="Danificado, não possui..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.trava_queda_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- cintas de ancoragem-->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Cintas de ancoragem
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.cintas_anco"
          @selected-data="(val) => (store.itensForm.values.cintas_anco = val)"
        />
      </div>
    </div>
  </div>

  <!-- cintas obs -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.cintas_anco?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.cintas_anco_descript"
        :info="'Inadequação da cinta'"
        label="Danificado, não possui..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.cintas_anco_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- mosquetões-->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Mosquetões
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="sis_resgate.condicao"
          :initialValue="store.itensForm.values.mosquetoes"
          @selected-data="(val) => (store.itensForm.values.mosquetoes = val)"
        />
      </div>
    </div>
  </div>

  <!-- cintas obs -->
  <Transition mode="out-in">
    <div
      class="md:col-span-2"
      v-if="store.itensForm.values.mosquetoes?.value == 'inadequado'"
    >
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.mosquetoes_descript"
        :info="'Inadequação dos mosquetões'"
        label="Danificado, não possui..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton
            @click="store.itensForm.values.mosquetoes_descript = undefined"
          />
        </template>
      </BaseInput>
    </div>
  </Transition>
</template>

<script setup>
import CleanInputButton from "../../utils/CleanInputButton.vue";
import SimpleSelect from "@/components/Select/SimpleSelect.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { dataExtinguisher } from "../../store";
import { sis_resgate } from "../../lookups/form";

const store = dataExtinguisher.state;
</script>
